import React, {useCallback, useRef, useState} from 'react';
import EmblaCarousel from "../EmblaCarousel/EmblaCarousel";
import {EmblaCarouselHandle} from "../EmblaCarousel/props";
import "./styles.scss";
import { GridBadge } from './components/GridBadge';
import { GridCounter } from './components/GridCounter';
import {ImageGridSingleProps} from "./props";
import {definedValue} from "../../../utils/input";
import arrowLeft from "../../../icons/arrow-left-lux.svg";
import arrowRight from "../../../icons/arrow-right-lux.svg";

const ImageGridSingle = (props: ImageGridSingleProps) => {  
  const [currentIndex, setCurrentIndex] = useState(definedValue(props.startCount,1));
  const { children, carouselClassName, showIndicators, handleCarouselItemClick , badge, prevOnClick, nextOnClick} = props;
  const total = definedValue(children.length, 0);
  const hideArrowButtons = definedValue(props.hideArrowButtons, true);
  const emblaCarouselRef = useRef<EmblaCarouselHandle>(null);

  const onClickLeft = useCallback((ev: React.MouseEvent<HTMLElement>) => {
    // istanbul ignore else
    if (emblaCarouselRef.current) {
      emblaCarouselRef.current.goToPrevious();
    }
    prevOnClick?.(ev as React.MouseEvent<HTMLButtonElement>);
  }, [emblaCarouselRef, prevOnClick]);
  
  const onClickRight = useCallback((ev: React.MouseEvent<HTMLElement>) => {
    // istanbul ignore else
    if (emblaCarouselRef.current) {
      emblaCarouselRef.current.goToNext();
    }
    nextOnClick?.(ev as React.MouseEvent<HTMLElement>);
  }, [emblaCarouselRef, nextOnClick]);

  const onCarluselItemClick = (ev: React.MouseEvent<HTMLElement>, index: number) => {
    // istanbul ignore else
    if (handleCarouselItemClick) {
      handleCarouselItemClick(ev, index);
    }
  }

  const onSlideChange = useCallback(() => {
    // istanbul ignore else
    if (emblaCarouselRef.current) {
      props.onSlideChange?.();
    }
  }, [emblaCarouselRef]);

  const className = carouselClassName ? `image-grid__carousel ${carouselClassName}` : "image-grid__carousel";
  return (
    <div className="image-grid__single">
      <GridBadge badge={badge} />
      <div className="image-grid__stripe image-grid__stripe--left" onClick={onClickLeft}>
        <button type="button" data-testid="left-arrow">
          <img src={arrowLeft} alt="arrow left" />
        </button>
      </div>
      <EmblaCarousel
        handleCarouselItemClick={onCarluselItemClick}
        onSlideChange={onSlideChange}
        classNames={{withIndicators: !!showIndicators}}
        carouselClassName={className}
        hideArrowButtons={hideArrowButtons}
        setSelectedIndex={(i:number) => setCurrentIndex(i + 1)}
        ref={emblaCarouselRef}
      >
       {children}
      </EmblaCarousel>
      <div className="image-grid__stripe image-grid__stripe--right" onClick={onClickRight}>
        <button type="button" data-testid="right-arrow">
          <img src={arrowRight} alt="arrow right" />
        </button>
      </div>
      <GridCounter 
        current={currentIndex}
        total={total}
      />
    </div>
  );
};
export default ImageGridSingle;

